import { slugify } from './slug-utils';
export const SUPPLEMENT_RECOMMENDATIONS = Object.freeze([
    // --- Alkalinity ---
    {
        slug: slugify('RHF 2-Part: Alkalinity (High pH)'),
        name: 'RHF 2-Part: Alkalinity (High pH)',
        brandOrType: 'DIY',
        parameter: 'Alkalinity',
        type: 'DIY',
        description: "Randy Holmes-Farley's classic DIY recipe using baked baking soda for a significant pH boost.",
    },
    {
        slug: slugify('New 2-Part Alkalinity (High pH Boost)'),
        name: 'New 2-Part Alkalinity (High pH Boost)',
        brandOrType: 'DIY',
        parameter: 'Alkalinity',
        type: 'DIY',
        description: 'A potent DIY recipe with Sodium Hydroxide for a very large pH boost. Use with extreme caution.',
    },
    {
        slug: slugify('Alkalinity (Standard - Bicarbonate)'),
        name: 'Alkalinity (Standard - Bicarbonate)',
        brandOrType: 'DIY',
        parameter: 'Alkalinity',
        type: 'DIY',
        description: 'A simple DIY recipe using Sodium Bicarbonate, which may slightly lower pH upon dosing.',
    },
    {
        slug: slugify('Reef Builder (Seachem)'),
        name: 'Reef Builder™',
        brandOrType: 'Seachem',
        parameter: 'Alkalinity',
        type: 'Commercial',
        description: 'Raises carbonate alkalinity without immediately impacting pH.',
    },
    {
        slug: slugify('Reef Carbonate (Seachem)'),
        name: 'Reef Carbonate™',
        brandOrType: 'Seachem',
        parameter: 'Alkalinity',
        type: 'Commercial',
        description: 'A concentrated blend of carbonate and bicarbonate salts to restore and maintain alkalinity.',
    },
    {
        slug: slugify('Alkalinity Supplements (Bulk Reef Supply)'),
        name: 'Alkalinity Supplements',
        brandOrType: 'Bulk Reef Supply',
        parameter: 'Alkalinity',
        type: 'Commercial',
        description: 'High-purity, pharmaceutical-grade supplements (soda ash, bicarbonate) to raise alkalinity.',
    },
    {
        slug: slugify('B-Ionic 2-Part (ESV)'),
        name: 'B-Ionic 2-Part',
        brandOrType: 'E.S.V.',
        parameter: 'Alkalinity',
        type: 'Commercial',
        description: 'The original two-part supplement system for maintaining calcium and alkalinity.',
    },
    {
        slug: slugify('C-Balance 2-Part (Two Little Fishies)'),
        name: 'C-Balance 2-Part',
        brandOrType: 'Two Little Fishies',
        parameter: 'Alkalinity',
        type: 'Commercial',
        description: 'A two-part method for replenishing calcium and alkalinity.',
    },
    // --- Calcium ---
    {
        slug: slugify('RHF 2-Part: Calcium'),
        name: 'RHF 2-Part: Calcium',
        brandOrType: 'DIY',
        parameter: 'Calcium',
        type: 'DIY',
        description: "Randy Holmes-Farley's classic DIY recipe for calcium.",
    },
    {
        slug: slugify('New 2-Part Calcium'),
        name: 'New 2-Part Calcium',
        brandOrType: 'DIY',
        parameter: 'Calcium',
        type: 'DIY',
        description: "The corresponding calcium part for the 'New 2-Part' high pH boost recipe.",
    },
    {
        slug: slugify('Calcium (Alternative Recipe)'),
        name: 'Calcium (Alternative Recipe)',
        brandOrType: 'DIY',
        parameter: 'Calcium',
        type: 'DIY',
        description: 'Another popular DIY recipe for a calcium stock solution.',
    },
    {
        slug: slugify('Reef Advantage Calcium (Seachem)'),
        name: 'Reef Advantage Calcium™',
        brandOrType: 'Seachem',
        parameter: 'Calcium',
        type: 'Commercial',
        description: 'A non-caustic optimized blend of ionic calcium to restore and maintain calcium levels.',
    },
    {
        slug: slugify('Reef Calcium (Seachem)'),
        name: 'Reef Calcium™',
        brandOrType: 'Seachem',
        parameter: 'Calcium',
        type: 'Commercial',
        description: 'A bioavailable polygluconate complexed calcium supplement.',
    },
    {
        slug: slugify('Calcium Supplements (Bulk Reef Supply)'),
        name: 'Calcium Supplements',
        brandOrType: 'Bulk Reef Supply',
        parameter: 'Calcium',
        type: 'Commercial',
        description: 'High-purity, pharmaceutical-grade calcium chloride to raise calcium levels.',
    },
    // --- Magnesium ---
    {
        slug: slugify('Magnesium (Mg) DIY'),
        name: 'Magnesium (Mg)',
        brandOrType: 'DIY',
        parameter: 'Magnesium',
        type: 'DIY',
        description: 'A DIY recipe using Magnesium Chloride and Magnesium Sulfate to create a balanced solution.',
    },
    {
        slug: slugify('Reef Advantage Magnesium (Seachem)'),
        name: 'Reef Advantage Magnesium™',
        brandOrType: 'Seachem',
        parameter: 'Magnesium',
        type: 'Commercial',
        description: 'An optimized blend of magnesium, chloride, and sulfate salts to restore depleted levels.',
    },
    {
        slug: slugify('Magnesium Supplements (Bulk Reef Supply)'),
        name: 'Magnesium Supplements',
        brandOrType: 'Bulk Reef Supply',
        parameter: 'Magnesium',
        type: 'Commercial',
        description: 'A two-component supplement to raise and maintain magnesium levels.',
    },
    // --- Nutrients ---
    {
        slug: slugify('Nitrate (NO3) DIY'),
        name: 'Nitrate (NO₃)',
        brandOrType: 'DIY',
        parameter: 'Nitrate',
        type: 'DIY',
        description: 'A DIY recipe to provide a primary nitrogen source for corals in Ultra-Low Nutrient Systems.',
    },
    {
        slug: slugify('Phosphate (PO4) DIY'),
        name: 'Phosphate (PO₄)',
        brandOrType: 'DIY',
        parameter: 'Phosphate',
        type: 'DIY',
        description: 'A DIY recipe to provide a critical phosphorus source for all living cells.',
    },
    {
        slug: slugify('NO3:PO4-X (NOPOX) (Red Sea)'),
        name: 'NO3:PO4-X (NOPOX)',
        brandOrType: 'Red Sea',
        parameter: 'Other',
        type: 'Commercial',
        description: 'A liquid carbon source to promote nutrient-reducing bacteria, lowering Nitrate and Phosphate.',
    },
    {
        slug: slugify('PhosGuard (Seachem)'),
        name: 'PhosGuard™',
        brandOrType: 'Seachem',
        parameter: 'Phosphate',
        type: 'Commercial',
        description: 'Rapidly removes phosphate and silicate from marine and freshwater aquaria.',
    },
    {
        slug: slugify('GFO Media (Bulk Reef Supply)'),
        name: 'GFO Media',
        brandOrType: 'Bulk Reef Supply',
        parameter: 'Phosphate',
        type: 'Commercial',
        description: 'Chemical filter media used to bind and remove phosphates from the aquarium water.',
    },
    // --- All-In-One ---
    {
        slug: slugify('All-For-Reef (Tropic Marin)'),
        name: 'All-For-Reef',
        brandOrType: 'Tropic Marin',
        parameter: 'All',
        type: 'Commercial',
        description: 'A highly concentrated, single-solution product that provides all essential minerals and trace elements.',
    },
    // --- Other ---
    {
        slug: slugify('Kalkwasser (Limewater) (General)'),
        name: 'Kalkwasser (Limewater)',
        brandOrType: 'General',
        parameter: 'All',
        type: 'DIY',
        description: 'A solution of calcium hydroxide used to supplement both calcium and alkalinity.',
    },
    {
        slug: slugify('Prime (Seachem)'),
        name: 'Prime®',
        brandOrType: 'Seachem',
        parameter: 'Other',
        type: 'Commercial',
        description: 'A complete and concentrated conditioner that removes chlorine, chloramine, and detoxifies ammonia, nitrite, and nitrate.',
    },
]);
//# sourceMappingURL=supplements.js.map